import { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Box, Button, Heading, Image, Paragraph, TextButton } from '@zillow/constellation-10';

import { RMWContext } from '../../../../providers/RMWContext';
import { RoutingSelectors } from '../../../../selectors';
import selectPropertyUtils from '../../../../utils/selectPropertyUtils';

import SelectPropertyConstants from '../../../../constants/SelectPropertyConstants';

import HomeVignette from '../../../../images/Homevignette@2x.png';

import { LAUNCHED_FROM_OPTIONS, STEPS } from '../constants';
import DeactivationModalCSEvents from '../../../../model/ClickstreamEvent/DeactivationModalCSEvents';

const propTypes = {
  launchedFrom: PropTypes.string.isRequired,
  step: PropTypes.string.isRequired,
  setDisplayDeactivateModal: PropTypes.func.isRequired,
  canUpsellLeases: PropTypes.bool,
};
const defaultProps = {};

const Congratulations = ({ launchedFrom, step, setDisplayDeactivateModal, canUpsellLeases }) => {
  const { paths } = useContext(RMWContext);
  const {
    properties: {
      currentProperty,
      currentProperty: {
        listingAlias,
        restrictions: { isLeaseBuilderRestricted },
      },
    },
    user,
  } = useSelector((state) => state);
  const propertyId = useSelector((state) => RoutingSelectors.makeListingId(state));
  const success = step === STEPS.CONGRATULATIONS;

  const isFromListingAvailabilityPage = launchedFrom === LAUNCHED_FROM_OPTIONS.LISTING_AVAILABILITY_PAGE;

  const bodyText = canUpsellLeases
    ? `Once you've selected a tenant, the next step is making it official. Quickly and easily upload a lease to store or send for secure e-signing. ${
        !isLeaseBuilderRestricted ? 'Or create your own customized lease with our help.' : ''
      }`
    : 'We appreciate your feedback.';

  const handleLeasesClick = () => {
    const leasesPath = selectPropertyUtils.getPathByType(SelectPropertyConstants.LEASES, listingAlias);
    DeactivationModalCSEvents.ContinuedToLeases({ user, currentProperty });

    window.router.updateLocation(leasesPath);
  };

  const handleViewPropertiesClick = () => {
    if (launchedFrom === LAUNCHED_FROM_OPTIONS.SOH) {
      return setDisplayDeactivateModal(false);
    }
    window.router.transitionTo(
      `${paths.propertiesPage}/${isFromListingAvailabilityPage ? propertyId : listingAlias}/dashboard/overview`,
    );
  };

  return (
    <Box css={{ marginTop: '400', marginBottom: '600', marginInline: '600' }}>
      <Box css={{ height: { base: '110px', md: '190px' } }}>
        <Image src={HomeVignette} alt="Publish-Success-Banner" />
      </Box>
      <Heading level={3} css={{ marginTop: '600', marginBottom: '400' }}>
        {success ? 'Congratulations!' : 'Thanks!'}
      </Heading>
      <Paragraph css={{ marginBottom: '600' }} data-test="deactivation-body">
        {bodyText}
      </Paragraph>
      <Box css={{ display: 'flex' }}>
        {canUpsellLeases && !isFromListingAvailabilityPage ? (
          <>
            <Button
              tone="brand"
              emphasis="filled"
              onClick={handleLeasesClick}
              data-eventid={DeactivationModalCSEvents.ContinuedToLeases.data_event_id}
              css={{ marginRight: '600' }}
            >
              Go to leases
            </Button>
            <TextButton onClick={handleViewPropertiesClick} data-testid="Congratulations-ViewPropertyOverviewButton">
              View property overview
            </TextButton>
          </>
        ) : (
          <Button tone="brand" emphasis="filled" onClick={handleViewPropertiesClick}>
            Back to property overview
          </Button>
        )}
      </Box>
    </Box>
  );
};

Congratulations.defaultProps = defaultProps;
Congratulations.propTypes = propTypes;

export default Congratulations;
